module.exports = __webpack_public_path__ + "static/media/coppercoast.aa4ab970.png";